import { ID_OTHER_AUTHORITY } from 'civil-status/components/step/form/last-step/accordions/section/list/list-authority';
import { SectionVM, DatiEventoMorte } from 'civil-status/view-models/step-form';

export const transformerDatiEventoMorte = (
  idEvento?: number,
  dataSection?: SectionVM
): DatiEventoMorte | undefined => {
  if (!dataSection) {
    return undefined;
  }

  if (
    !(
      dataSection.authority ||
      dataSection.typeCommunication ||
      dataSection.dateCommunication ||
      dataSection.numberAppearing
    )
  ) {
    return undefined;
  }

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    descTrasmissione: dataSection.authority
      ? dataSection.authority.id === ID_OTHER_AUTHORITY
        ? dataSection.otherAuthority || undefined
        : dataSection.authority.value || undefined
      : undefined,
    tipoTrasmissione: dataSection.typeCommunication?.id?.toString() || undefined,
    dataTrasmissione: dataSection.dateCommunication
      ? dataSection.dateCommunication.toFormat('yyyy-MM-dd')
      : undefined,
    numComparenti: dataSection.numberAppearing
      ? Number.parseInt(dataSection.numberAppearing)
      : undefined,
  };
};
